import React, { useMemo } from 'react'
import { ProjectMilestonesData } from '../GeneralInformation/typesExtendedReport'

export const useProjectMilestonesMappedData = (data: ProjectMilestonesData | null | undefined) => {

    return useMemo(() => {
        if (!data) return null

        return {
            LegislativeApproval: data.projectPendingSignatureLegislativeApproval,
            NotFullyDisbursed: data.projectExtendedNotFullyDisbursed,
            DisbursementEligibility: data.projectPendingDisbursementEligibility,
            AboutToExpire: data.projectsAboutToExpire,
            expiredProjects: data.expiredProjects
        }

    }, [data])

}
